import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const Notify = ({ open, anchorOrigin, onClose, errors, successMessage }) => {
  const title = Object.keys(errors).length > 0 ? "Error" : "Alert";
  const message = Object.keys(errors).length > 0
    ? (errors?.errormessage || errors?.message || 'Something went wrong !!')
    : (successMessage || 'Success !!');

  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-action-btn"
            onClick={onClose}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

Notify.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  errors: PropTypes.object,
  anchorOrigin: PropTypes.object,
  successMessage: PropTypes.string
};

export default Notify;